$(() => {
  const fileUploadForm = $(".a-profile-police__fileupload form")[0];
  const fileUploadButton = $(fileUploadForm).find('input[type="file"]')[0];
  $(fileUploadButton).val(null);

  $(fileUploadButton).on("change", () => {
    $(fileUploadForm).submit();
  });
});
